<template>
  <section class="approvalstatusbg">
    <div class="approvaldiv">
      <div class="approvalinnerdiv">
        <!-- Empty div, placeholder for future content -->
      </div>

      <div class="approvalinnerdiv" v-for="(item, index) in ApprovalgetList" :key="index">
        <div class="approvalcard">
          <img src="../../assets/Img/icons/tick-01.svg" />

          <div>
            <p class="statusheading">
              {{ item.EntityOperationName }} a {{ approvaldetails?.HeaderName }}
            </p>
            <p class="statusdate">
              {{ approvaldetails?.CreatedAt }}
            </p>
          </div>
        </div>

        <div v-if="item.IsApproved !== undefined" class="approvalcard">
          <img v-if="item.IsApproved === 1" src="../../assets/Img/icons/tick-01.svg" />
          <img v-else-if="item.IsApproved === 2" src="../../assets/Img/icons/tick2.svg" />
          <img v-else-if="item.IsApproved === 3" src="../../assets/Img/icons/close-01.svg" />
          <img v-else src="../../assets/Img/icons/hellipsisbackground.svg" />

          <div>
            <p class="statusheading" v-if="item.IsApproved === 1">
              Approved By {{ item.UserName }}
            </p>
            <p class="statusheading" v-if="item.IsApproved === 2">
              Approved By {{ item.UserName }}
            </p>
            <p class="statusheading" v-if="item.IsApproved === 3">
              Declined By {{ item.UserName }}
            </p>

            <p class="statusdate">
              {{ item.ApprovedAt }}
            </p>
            <p class="statusremarks" :title="item.Remarks">
              {{ item.Remarks ? `Remarks : ${item.Remarks}` : "" }}
            </p>
          </div>
        </div>

        <div v-if="item.IsApproved === 0" class="approvalcard">
          <img src="../../assets/Img/icons/hellipsisbackground.svg" />
          <div>
            <p class="statusheading">
              Approval Pending with {{ item.RoleName }}
            </p>
          </div>
        </div>

        <i class="pi pi-arrow-right approvalrightarrow" v-if="index !== ApprovalgetList.length - 1"
          style="color: #e1e1e1"></i>
        <i class="pi pi-arrow-down approvaldownarrow" v-if="index !== ApprovalgetList.length - 1"
          style="color: #e1e1e1"></i>
      </div>

      <div class="approvalinnerdiv">
        <div class="approvalcard">
          <img v-if="!isAllApproved" src="../../assets/Img/icons/hellipsisbackground.svg" />
          <img v-else src="../../assets/Img/icons/tick-01.svg" />

          <div>
            <p class="statusheading">
              {{ approvaldetails?.HeaderName }} Approved Successfully
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from 'vue';

type ApprovalItem = {
  EntityOperationName?: string;
  IsApproved?: number;
  UserName?: string;
  ApprovedAt?: string;
  Remarks?: string;
  RoleName?: string;
};

export default defineComponent({
  props: {
    ApprovalgetList: {
      type: Array as () => ApprovalItem[],
      default: () => [],
    },
    approvaldetails: {
      type: Object as () => {
        HeaderName?: string;
        CreatedAt?: string;
      },
      default: () => ({}),
    },
  },
  setup(props) {
    const isAllApproved = computed(() =>
      props.ApprovalgetList.every(
        (item) => item.IsApproved === 1 || item.IsApproved === 2
      )
    );

    return {
      isAllApproved,
    };
  },
});
</script>

<style lang="scss" scoped>
.approvalstatusbg {
  background-color: #ffffff;
  box-shadow: 0px 3px 6px #00000029;
  padding: 5px 0;
  z-index: 10;
  position: relative;
  width: 100%;
  overflow: auto;
}

.approvaldiv {
  display: flex;
  align-items: center;
  gap: 5px;
  margin: 0 auto;
  width: max-content;
}

.approvalinnerdiv {
  display: flex;
  align-items: center;
  gap: 5px;
}

.approvalcard {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 0 15px;

  img {
    width: 25px;
  }

  .statusheading {
    font-size: 14px;
    font-weight: 500;
  }

  .statusdate {
    font-size: 12px;
    color: #999999;
  }

  .statusremarks {
    font-size: 12px;
    color: #999999;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    cursor: pointer;
  }
}

.approvalrightarrow {
  display: block;
}

.approvaldownarrow {
  display: none;
}

@media only screen and (max-width: 1023px) {
  .approvaldiv {
    flex-direction: column;
  }

  .approvalinnerdiv {
    flex-direction: column;
  }

  .approvalrightarrow {
    display: none;
  }

  .approvaldownarrow {
    display: block;
  }
}
</style>
